import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

interface IOverlayLoaderProps {
  isVisible: boolean;
}

export const OverlayLoader = observer((props: IOverlayLoaderProps): ReactElement => {
  return (
    <>
      {props.isVisible && (
        <span>
          <div className='button-with-loader-overlay left' />
          <div className='button-with-loader-overlay right' />
        </span>
      )}
    </>
  );
});
